/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import './DeepAIInsights.css';
import { useAppSelector } from '../../rmsReduxStore/rmsReduxHooks';
import { getDashboardReducer } from '../../rmsReduxStore/reduxExports';
import { Icon } from '../../globalUtils/globalIcons';
import { RectangularSkeleton } from '../../globalUtils/SkeletonDesign/SkeletonDesign';


const DeepAIInsights: React.FC = () => {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedTableIndex, setSelectedTableIndex] = useState(0);
  const { newDashboardAIInsights } = useAppSelector(getDashboardReducer);
  const insightsTableHeight = 400;

  const insightSlides: INewDashboardAIInsights[] | null = newDashboardAIInsights;

  const normalizeSlides = (slides: any) => {
    const result: any[] = [];
    
    slides?.forEach((slide, i) => {
      if (slide && slide?.type === 'table' && slide.cards.length > 2) {
        for (let j = 0; j < slide.cards.length; j += 2) {
          result.push({
            ...slide,
            cards: slide.cards.slice(j, j + 2),
            headingIndex: i,
          });
        }
      } else {
        result.push({ ...slide, headingIndex: i });
      }
    });
  
    return result;
  };
  
const filteredSlides = normalizeSlides(insightSlides);
  // const filteredSlides = insightSlides;

  const handlePrev = () => {
    setCurrentIndex(prev => Math.max(prev - 1, 0));
    setSelectedTableIndex(0);
  };

  const handleNext = () => {
    setCurrentIndex(prev => Math.min(prev + 1, filteredSlides.length - 1));
    setSelectedTableIndex(0);
  };

  const currentSlide = filteredSlides[currentIndex];

  return (
      <div className="widget-wrap ai-insights-card">
        <div className="widget-header ai-insight-header-container">
          <div className="chart-header-ai">
            <div className="widget-heading ai-insights-heading">Deep AI Insights</div>
          </div>
        </div>
        {
        !insightSlides ?
          <div style={{ height: `${insightsTableHeight}px` }}>
            <RectangularSkeleton skeletonContainerClassName='' />
          </div>
        :
        (insightSlides as any).length === 0 ? 
        <div className='no-data-text' >
          No data available
        </div>
        :
        <div className="widget-body insight-navigation">
          {/* Left Arrow */}
          <div
            className={`arrow-icon left ${currentIndex === 0 ? 'disabled' : ''}`}
            onClick={handlePrev}
          >
            <Icon iconClassName={'left-navigation-arrow-with-shadow'} />
          </div>
          {/* Slide Content */}
          <div className="insight-list active-slide">
            <div className="insight-list-header">
              <div className="insight-list-header-count">
                {(currentSlide?.headingIndex + 1).toString().padStart(2, '0')}
              </div>
              <div className="insight-list-header-title-wrap">
                <div className='insight-list-title'>
                  {currentSlide?.subheading || ''}
                </div>
              </div>
            </div>
            <div className='insights-list-wrap'>
              {currentSlide?.type === 'table' && (
                    <div className="ai-insight-toggle">
                      {currentSlide?.cards.map((card, index) => (
                        <div
                          key={index}
                          className={`ai-toggle-option ${selectedTableIndex === index ? 'active' : ''} ${currentSlide?.cards?.length != 1 ? 'cursor-pointer' : ''}`}
                          onClick={() => setSelectedTableIndex(index)}
                        >
                          {card.title}
                        </div>
                      ))}
                    </div>
                  )}
              <div className="insight-card-table">
              {currentSlide?.type === 'table'
                ? 
                [currentSlide?.cards[selectedTableIndex]]?.map((card, cardIndex) => (
                  <div className="insights-table-card-list" key={cardIndex}>
                    {card.table.rows.map((row, rowIndex) => (
                      <div key={rowIndex} className="insight-table-card">
                        <div className="insight-header">
                          <div className="rms__icon newdashboard-ai-insights-star" />
                          <div className="insights-header-title">{row[0]}</div>
                        </div>
                        <div className="insight-description">
                          <div className="row-sub row-1">{row[1]}</div>
                          <div className="row-sub row-2">
                            <Icon iconClassName='ai-insights-warning-icon'/>
                            <div>{row[2]}</div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
              ))
                : currentSlide?.cards.map((card, cardIndex) => (
                    <div key={cardIndex} className="insight-card">
                      <div className="insight-header">
                        <div className="rms__icon newdashboard-ai-insights-star" />
                        <div className="insights-header-title">{card.title}</div>
                      </div>
                      <ul className="insights-description">
                        {(card.points ?? []).map((point, pointIndex) => (
                          <li key={pointIndex}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
            </div>
          </div>
          {/* Right Arrow */}
          <div
            className={`arrow-icon right ${currentIndex === filteredSlides.length - 1 ? 'disabled' : ''}`}
            onClick={handleNext}
          >
            <Icon iconClassName={'right-navigation-arrow-with-shadow'} />
          </div>
        </div>
        }
      </div>
  );
//     <div className="ai-insights-card">
//       <div className="ai-insight-header-container">
//         {/* <div className='rms__icon ai-insights-icon-dark' /> */}
//         <div className='chart-header-ai'>
//           <div className='ai-insights-heading'>
//             Deep AI Insights
//           </div>
//           {/* <div className='ai-insights-sub-heading'>
//             Insights based on analysis of 07 million datapoints
//           </div> */}
//         </div>
//       </div>
//       <div className="insight-list">
//   {filteredSlides.map((slide, index) => (
//     <div key={index} className="insight-list-section">
//       <div className="insight-list-header">
//         <div className='insight-list-header-count'>
//           {index + 1 < 10 ? '0' + (index + 1) : index + 1}
//         </div>
//         <div className='insight-list-header-title'>
//           {slide.subheading}
//         </div>
//       </div>
//       {slide.cards.map((card, cardIndex) => (
//         <div key={cardIndex} className="insight-card">
//           <div className="insight-header">
//             <div className="rms__icon green-checkbox-check-tick" />
//             <div className="insights-header-title">{card.title}</div>
//           </div>
//           <ul className="insights-description">
//             {(card.points ?? []).map((point, pointIndex) => (
//               <li key={pointIndex}>{point}</li>
//             ))}
//           </ul>
//         </div>
//       ))}
//     </div>
//   ))}
// </div>

//     </div>
//   );
};

export default DeepAIInsights;